module.exports = __webpack_public_path__ + "img/激活额度 (2).bacb68bb.png";